import React from 'react'
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../theme";
import Logo from '../img/piska.png'
import MenuIcon from '@mui/icons-material/Menu';
import Divider from '@mui/material/Divider';

import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import LogoutIcon from '@mui/icons-material/Logout';

import styles from './TopBar.module.css'; 
import DefaultPfp from '../img/default_pfp.jpeg'
import { getImageUrl, truncate } from '../utils/apiHelpers';

import SiteLinks from './SiteLinks';
import { Link } from 'react-router-dom';

import { useAuth } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

import api from '../utils/api';

function TopBar() {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const { user, setToken } = useAuth();
    const navigate = useNavigate();

    // Example frontend logout function
    const logout = async () => {
        try {
            await api.post('/clear_refresh_token', {}, {
                withCredentials: true
            });
            setToken(null); // Clear your auth context
        } catch (error) {
            console.error('Failed to logout:', error);
        }
    };

    console.log(user)
    
    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" padding="10px">
                <IconButton onClick={() => setMenuOpen(!menuOpen)}>
                    <MenuIcon style={{color: colors.gray[100]}}/>
                </IconButton>
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <IconButton onClick={colorMode.toggleColorMode} disableTouchRipple>
                        {theme.palette.mode === 'dark' ? (
                            <DarkModeOutlinedIcon/>
                        ) : (
                            <LightModeOutlinedIcon/>
                        )}
                    </IconButton>
                    <Typography
                        variant="h5"
                        color={colors.ceriseAccent[900]}
                        fontWeight="medium" 
                        sx={{m : "0 10px 0 0" }}
                        >
                        Baxappen
                    </Typography>
                    <img src={Logo} style={{width: '40px'}} alt="P2CM"/>
                </Box>
            </Box>
            <Divider sx={{ bgcolor: colors.gray[100] }}/>
            <Box className={`${styles.modal} ${menuOpen ? styles.modalOpen : ''}`} display="flex" flexDirection="column" sx={{backgroundColor: colors.gray[900], borderRight: 1, borderColor: colors.gray[400]}}>
                {
                    user !== null ?
                    <Box display="flex" alignItems="center" padding="10px" sx={{borderBottom : 1, borderColor: colors.gray[400]}}>
                        <IconButton component={Link} to="/profile" disableRipple>
                            <img src={user.profile_image_path == "" ? DefaultPfp : getImageUrl(user.profile_image_path)} alt="" width="50px" height="50px"/>
                        </IconButton>
                        <Typography
                            variant="h4"
                            color={colors.ceriseAccent[900]}
                            fontWeight="medium" 
                            sx={{m : "0 0 0 5px" }}
                            >
                                {truncate(user.name, 7)}
                        </Typography>
                        <Box display="flex" justifyContent="flex-end" sx={{width: "100%"}}>
                            <IconButton onClick={logout}>
                                <LogoutIcon style={{color: colors.gray[100]}}/>
                            </IconButton>
                            <IconButton onClick={() => setMenuOpen(!menuOpen)}>
                                <MenuIcon style={{color: colors.gray[100]}}/>
                            </IconButton>
                        </Box>
                    </Box>
                : null
                }
                <SiteLinks home admin/>
            </Box>
        </Box>
    )
}

export default TopBar;